import { lazy } from 'react';

export const MoreTransaction = lazy(() => import('./MoreTransaction.component'));
